import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cda69ed6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-outer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logoff" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://keycloak.studioin.cloud/realms/cloudstudio/protocol/openid-connect/logout?redirect_uri=https://studioin.cloud" }, "Log off")
], -1))
const _hoisted_3 = { class: "box-inner" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "logo",
    src: "/logo.svg"
  })
], -1))
const _hoisted_5 = { class: "title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, null, -1))
const _hoisted_7 = { class: "workspaces" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "workspace-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "icon",
    src: "/studiocloud_gradient-SF.png"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "workspace-name" }, "CodAL workspace", -1))
const _hoisted_10 = { class: "workspace-button-box" }
const _hoisted_11 = { class: "workspace-button" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://keycloak.studioin.cloud/realms/cloudstudio/protocol/openid-connect/auth?response_type=code&client_id=theia-cloud&redirect_uri=https://studioin.cloud&kc_action=UPDATE_PASSWORD",
    class: "footer-link"
  }, "Change Password"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.codasip.com/",
    target: "_blank",
    class: "footer-link right"
  }, "www.codasip.com")
], -1))
const _hoisted_13 = { style: {"margin-left":"2.5em","padding":"0 7em 2em 0"} }
const _hoisted_14 = {
  key: 0,
  class: "loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CButton = _resolveComponent("CButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, " Welcome back, " + _toDisplayString(_ctx.myuser) + " ! ", 1),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_CButton, {
              type: "button",
              class: "button",
              onClick: _ctx.showModal
            }, {
              default: _withCtx(() => [
                _createTextVNode("Open")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _withDirectives(_createVNode(_component_Modal, {
              onReject: _ctx.rejectTerms,
              onAccept: _ctx.acceptTerms
            }, null, 8, ["onReject", "onAccept"]), [
              [_vShow, _ctx.licenceVisible]
            ])
          ])
        ])
      ])
    ]),
    _hoisted_12,
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.text), 1),
      (_ctx.showSpinner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14))
        : _createCommentVNode("", true)
    ])
  ]))
}